import { escapeHTML } from '../../utils/escape.js';

/**
 * Banner del Panel Admin (`/admin`) con las jornadas abiertas hace
 * más de 12 h (F-B, owner decision 2026-09-27: avisar las salidas olvidadas
 * sin esperar a que el admin entre a Fichadas). Render puro: `js/admin.js`
 * decide cuándo leer y pinta el resultado en `#admin-jornadas-abiertas-banner`
 * (que `AdminShell` solo crea en el panel admin). Sin mensaje, no pinta nada.
 *
 * El botón lleva a Fichadas, donde cada jornada abierta tiene "Cerrar
 * jornada" (F-C) — el banner nunca escribe nada por su cuenta.
 * @param {{ mensaje?: string }} [params]
 * @returns {string}
 */
export function JornadasAbiertasBanner({ mensaje } = {}) {
    if (!mensaje) return '';
    return `
        <div role="status" class="flex flex-wrap items-center justify-between gap-3 mb-6 rounded-2xl border border-amber-300 bg-amber-50 px-5 py-4 text-amber-900 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-100">
            <p class="text-sm font-bold min-w-0 flex-1">
                <i class="fa-solid fa-triangle-exclamation mr-2" aria-hidden="true"></i>${escapeHTML(mensaje)}
            </p>
            <button type="button" data-action="jornadas-abiertas-ir" class="shrink-0 px-4 py-2 rounded-xl border border-amber-400 text-xs font-black uppercase tracking-widest hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-colors">
                Ir a Fichadas
            </button>
        </div>
    `;
}
